import { Component, computed, effect, inject, input } from '@angular/core';
import { ModalConfirmProps } from '../models/modal-confirm';
import { Store } from '@ngrx/store';
import { SettingActions } from '../../state/settings/setting.actions';
import { Divider } from "./divider";
import { NgClass } from '@angular/common';

@Component({
  selector: 'app-modal-confirm',
  imports: [Divider, NgClass],
  template: `
    <dialog id="modal-confirm" class="modal">
      <div class="modal-box">
        <div class="pb-3">
          <h3 class="font-bold text-lg">{{ modal()?.title }}</h3>
          <p class="py-4">{{ modal()?.description }}</p>
        </div>
        <app-divider [isOrizontalDivider]="true" borderColor="border-[#D9DADB]" />
        <div class="mt-6">
          <form method="dialog" class="w-full grid grid-cols-2 gap-1">
            <button id="close-modal" (click)="cancel()" class="btn-white w-full">{{modal()?.btnCloseLabel ?? 'Annulla'}}</button>
            <button [disabled]="modal()?.isBtnConfirmDisabled ? modal()?.isBtnConfirmDisabled : null" (click)="confirm()"  [ngClass]="{
    'cursor-not-allowed opacity-50': modal()?.isBtnConfirmDisabled,
    'cursor-pointer': !modal()?.isBtnConfirmDisabled
  }" class="btn-blue disabled:cursor-not-allowed">{{modal()?.btnConfirmLabel ?? 'Conferma'}}</button>
          </form>
        </div>
      </div>
    </dialog>`,
  styles: ``,
})
export class ModalConfirm {
  modal = input<ModalConfirmProps | null>(null);

  store = inject(Store)

  constructor() {
    effect(() => {
      if (this.modal() && this.modal()!.open) {
        (document.getElementById('modal-confirm') as HTMLFormElement)['showModal']();
      }
    });
  }

  confirm() {
    this.store.dispatch(SettingActions.openModal(
      {
        ...this.modal(),
        open: false,
        confirm: true,
      }
    ));
  }

  cancel() {
    this.store.dispatch(SettingActions.closeModal());
  }
}
